var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apexchart',{attrs:{"options":_vm.chartOptions,"series":_vm.series,"type":"bar"}})
}
var staticRenderFns = []

export { render, staticRenderFns }